import { FunctionComponent } from 'react';
import clsx from 'clsx';

import {
  IconAirplane,
  IconBeer,
  IconCarrot,
  IconChefHat,
  IconCocktail,
  IconFaceCool,
  IconPeopleFamily,
  IconPlate,
  IconPlateHeart,
  IconTheater,
  IconToGo,
  IconWineGlass,
} from '@tock/icons';
import AchievementCircle, {
  variantToClassnameModifier,
} from 'components/profile/achievements/AchievementCircle';
import IconClock from 'components/icons/svgr/IconClock';
import IconGoodTaste from 'components/icons/svgr/badges/IconGoodTaste';

export interface Props {
  name: string;
  level?: number;
  isAchieved?: boolean;
  className?: string;
  variant?: AchievementCircleVariant;
}

export type AchievementCircleVariant = 'default' | 'large';

const Achievement: FunctionComponent<Props> = ({
  name,
  level,
  isAchieved,
  className,
  variant = 'default',
}) => {
  const colorAndIcon = achievementToColorAndIcon[name] || {
    color: 'Achievement_purple',
    Icon: IconClock,
  };
  const modifierClassName = clsx(
    className,
    isAchieved ? colorAndIcon.color : 'Achievement_unachieved'
  );

  const iconClassname = clsx('Achievement-icon', variantToClassnameModifier[variant]);
  return (
    <AchievementCircle className={modifierClassName} level={level || 0} variant={variant}>
      <colorAndIcon.Icon className={iconClassname} viewBox="0 0 24 25" />
    </AchievementCircle>
  );
};

const achievementToColorAndIcon: Dictionary<{
  color: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon: (props: any) => JSX.Element;
}> = {
  Adventurer: {
    color: 'Achievement_adventurer',
    Icon: IconTheater,
  },
  'Fine Diner': {
    color: 'Achievement_fineDiner',
    Icon: IconChefHat,
  },
  'First Course': {
    color: 'Achievement_firstCourse',
    Icon: IconPlateHeart,
  },
  Globetrotter: {
    color: 'Achievement_globetrotter',
    Icon: IconAirplane,
  },
  // Deliberately keeping this so that it won't break when
  'Good Taste': {
    color: 'Achievement_goodTaste',
    Icon: IconGoodTaste,
  },
  Herbivore: { color: 'Achievement_herbivore', Icon: IconCarrot },
  'Hopped Up': { color: 'Achievement_hoppedUp', Icon: IconBeer },
  Oenophile: { color: 'Achievement_oenophile', Icon: IconWineGlass },
  Socialite: {
    color: 'Achievement_socialite',
    Icon: IconPeopleFamily,
  },
  Spirited: { color: 'Achievement_spirited', Icon: IconCocktail },
  'Star Collector': {
    color: 'Achievement_goodTaste',
    Icon: IconGoodTaste,
  },
  Trendsetter: {
    color: 'Achievement_trendsetter',
    Icon: IconFaceCool,
  },
  'True Gourmand': {
    color: 'Achievement_trueGourmand',
    Icon: IconPlate,
  },
  'Home Chef': { color: 'Achievement_homeChef', Icon: IconToGo },
};

export default Achievement;
